import { FC, memo } from 'react';
import Link from 'next/link';
import classnames from 'classnames';
import styles from './index.module.scss';
import { ExtData } from '../../models/model';

export interface ExtCardProps {
  dataSource: ExtData[];
  count?: number;
}

const DefaultCount = 5;

const ExtCard: FC<ExtCardProps> = ({ dataSource, count = DefaultCount }) => (
  <div className={styles.container}>
    <div className={classnames(styles.item, styles.title)}>其他人还看了</div>
    <ul>
      {dataSource?.slice(0, count).map((item) => (
        <li className={styles.item} key={item.ekey}>
          <Link href={item.ekey}>{item.text}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export default memo(ExtCard);
